import React from 'react';
import { whatCards } from './data';
import './Styles/What.scss';
import Card from '../../Shared/Cards/HubCard/Card';
const What=()=>{
    return(
        <div className="what-hub">
            <h1>What' On</h1>
            <p>Catch up on our latest webinars and keep an eye out for upcoming events for you to join</p>
            <div className="cards">
                {whatCards.map((d) =>{
                    return(
                        <Card {...d}/>
                    )
                })}
            </div>
        </div>
    )
};
export default What;